// /utils/wsListeners/authListeners.js

import { refreshAuthToken } from "../refreshAuthToken";
import { setBlockLoginAutoRedirect } from "../../src/authSessionStorage";

/** Serialize auth:token-expired handling so concurrent 419 + immediate reconnect doesn't loop on missing_cookie */
let authTokenExpiredChain = Promise.resolve();

export function attachAuthListeners(socket, { connectWs, disconnectWs }) {
  

  //console.log(`[${ts()}][AUTH DEBUG] WS event received`);
  function ts() {
    return new Date().toISOString();
  }

  socket.onAny((event, payload) => {
  //console.log('[AUTH WS EVENT]', event, payload);
});

  const onError = async (payload) => {
    console.warn("[Auth WS] error received:", payload);

    if (payload?.code === 419 || payload?.message?.includes("Token expired")) {
      console.warn("[Auth WS] Token expired → refreshing...");

      const ok = await refreshAuthToken();
      if (ok) {
        console.info("[Auth WS] Token refreshed → reconnecting WS...");
        connectWs();
      } else {
        console.warn("[Auth WS] Refresh failed → disconnecting user");
        disconnectWs();
      }
    }
  };

  const onAuthError = async (payload) => {
    console.warn("[Auth WS] auth:error received:", payload);

    if (payload?.code === 419) {
      const ok = await refreshAuthToken();
      if (ok) connectWs();
    }
  };

  const onTokenExpiring = async (payload) => {
    //console.log("[Auth WS] auth:token-expiring received:", payload);

    const ok = await refreshAuthToken();
    if (ok) {
      console.info("[Auth WS] Early refresh OK → no disconnect required");
    }
  };

  const onTokenExpired = (payload) => {
    console.warn("[Auth WS] auth:token-expired received:", payload);

    authTokenExpiredChain = authTokenExpiredChain
      .then(async () => {
        const ok = await refreshAuthToken();
        if (ok) {
          console.info("[Auth WS] Token refreshed after token-expired → scheduling WS reconnect...");
          await new Promise((r) => setTimeout(r, 50));
          connectWs();
          window.dispatchEvent(new CustomEvent("auth-ws-refreshed"));
        } else {
          console.warn("[Auth WS] Refresh failed → disconnecting user");
          disconnectWs();
        }
      })
      .catch((e) => {
        console.warn("[Auth WS] token-expired handler chain error:", e?.message || e);
      });
  };

  socket.on("error", onError);
  socket.on("auth:error", onAuthError);
  socket.on("auth:token-expiring", onTokenExpiring);
  socket.on("auth:token-expired", onTokenExpired);


  const onUserUpdate = (payload) => {
    console.log('[Auth WS] auth:user:update received:', payload);

    // English comment: forward payload to window for AuthContext to consume
    window.dispatchEvent(new CustomEvent("auth-user-update", { detail: payload }));
  };

  socket.on("auth:user:update", onUserUpdate);

  const onLogout = (payload) => {
    console.warn("[Auth WS] auth:logout received:", payload);
    setBlockLoginAutoRedirect();
    disconnectWs();
    window.dispatchEvent(
      new CustomEvent("auth:force-logout", {
        detail: { reason: "session-revoked", ...payload },
      })
    );
  };

  socket.on("auth:logout", onLogout);

  return () => {
    socket.off("error", onError);
    socket.off("auth:error", onAuthError);
    socket.off("auth:token-expiring", onTokenExpiring);
    socket.off("auth:token-expired", onTokenExpired);
    socket.off("auth:user:update", onUserUpdate);
    socket.off("auth:logout", onLogout);
  };
}
